import React from 'react';
import LinkService from "../../services/LinkService";
import logoImg from "../../assets/images/main_page_logo.jpg";
export default function MyName() {
    let linkService = new LinkService()

    return (
        <nav className="navbar navbar-expand-lg bg-body-tertiary">
        <div className="container-fluid">
                     <img src={logoImg} alt={"Flower Dust Music logo" }/><br/>

          <a className="navbar-brand" href="#"><b>Flower Dust Music</b></a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a className="nav-link active" aria-current="page" href="/">Home</a>
              </li>
              <li className="nav-item">
                <a className="nav-link active" aria-current="page" href="/contact">Contact</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>);
  }
